import React, { useContext } from 'react';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import '../../App.css';
import { AppContext } from '../../contexts/AppContext';

export default function Group() {
  const { useMobileView } = useContext(AppContext);

  return (
      <Box
        sx={{
          border: '2px solid white',
          borderRadius: '4px',
          padding: '24px',
          borderBottom: useMobileView ? 'none' : '2px solid white'
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
              The Group...
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
            <b>Plan <span style={{ color: 'red' }}>A</span></b> Media group is a collaborative space for upleveling 
            the potential of your project and includes access to a diverse team of leading edge industry experts. 
            If you need services beyond my scope, the <b>Plan <span style={{ color: 'red' }}>A</span></b> Media circle connects you to a trusted team of 
            established entertainment professionals to assist in securing solutions tailored to fulfill your 
            project's specific requirements.
            </Typography>
          </Grid>
        </Grid>
      </Box>
  );
}
